var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container opening-hours-header-img"},[(_vm.showHeader == 1)?_c('div',{staticClass:"header-main-img"},[_c('img',{staticClass:"img-fluid header-img",attrs:{"src":_vm.headerImage,"alt":"header-img"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }